import BaseAPI from '../api'

export default class CMSApi extends BaseAPI {

    static getAppLogo(): Promise<any> {
        return this.api.get(`app-logo`, {})
            .then((res) => res)
    }
    static patchAppLogo(formData: any): Promise<any> {
        return this.api.patch(`app-logo`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        })
            .then((res) => res)
    }
    static getLoginBackground(): Promise<any> {
        return this.api.get(`login-background`, {})
            .then((res) => res)
    }
    static patchLoginBackground(formData: any): Promise<any> {
        return this.api.patch(`login-background`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
        })
            .then((res) => res)
    }
}